// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/fonts.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'FiraGO';
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

body {
  margin: 0;
  font-family: 'FiraGO', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
}

@media (max-width: 1279px) {
  body.fixed {
    overflow: hidden;
    height: 100vh;
  }
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

*:not(.paralax-container *) {
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
}

a {
  text-decoration: none;
}

::-webkit-scrollbar-track {
  background-color: #091e424f;
}

::-webkit-scrollbar-thumb {
  background-color: #091e42;
  border-radius: 4px;
}

body {
  scrollbar-color: #091e42 #091e424f;
  scrollbar-width: thin;
}

body::-webkit-scrollbar-track {
  background-color: #091e424f;
}

body::-webkit-scrollbar-thumb {
  background-color: #091e42;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,2DAAoD;AACtD;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;aACW;AACb;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: 'FiraGO';\n  font-style: normal;\n  font-weight: 400;\n  src: url('./assets/fonts/fonts.woff') format('woff');\n}\n\nbody {\n  margin: 0;\n  font-family: 'FiraGO', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 16px;\n}\n\n@media (max-width: 1279px) {\n  body.fixed {\n    overflow: hidden;\n    height: 100vh;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n*:not(.paralax-container *) {\n  box-sizing: border-box;\n  transition: all 0.3s ease-in-out;\n}\n\na {\n  text-decoration: none;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #091e424f;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #091e42;\n  border-radius: 4px;\n}\n\nbody {\n  scrollbar-color: #091e42 #091e424f;\n  scrollbar-width: thin;\n}\n\nbody::-webkit-scrollbar-track {\n  background-color: #091e424f;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: #091e42;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
